import { MILITARY_FORMAT } from '@helpers/datetime';
import { getEstimatedFee } from '@helpers/getEstimatedFee';
import { eventDuration, isAmericanExpress, serviceFee, totalEventRate } from '@helpers/post';
import { rateTypeNameFinder } from '@helpers/rateTypeName';
import { get } from 'lodash';
import moment from 'moment';
import { useState } from 'react';

export const EstimatedCost = ({ shifts, shiftLocation, rateTypes, payment, currentUser }) => {
  const [showBreakdown, setShowBreakdown] = useState(true);
  const payRate = get(shiftLocation, 'payRate', 0);
  const rateTypeId = get(shiftLocation, 'rateTypeId', 0);
  const maxStartTime = Math.max(...shifts.map(({ startTime }) => moment(startTime, MILITARY_FORMAT)));

  const totalCapacity = shifts.reduce((acc, shift) => acc + shift.capacity, 0);
  const totalDuration = eventDuration({ shifts });
  const totalRate = totalEventRate({ shifts });

  const fee = getEstimatedFee(maxStartTime, 0, isAmericanExpress(payment));
  const locationServiceFee = serviceFee({ shifts, payment, currentUser });
  const estimatedTotal = locationServiceFee + totalRate;

  const displayRate = () => {
    const type = rateTypeNameFinder(rateTypes, rateTypeId);
    return `${payRate}/${type}`;
  };

  const setPrecision = amount => Number(amount).toFixed(2);

  return (
    <div className="estimated-costs">
      <div className="estimated-total-container">
        <p className="estimated-total-header">
          Estimated total for this event <span>${setPrecision(estimatedTotal)}</span>
        </p>
        <span className="breakdown-toggle" onClick={() => setShowBreakdown(!showBreakdown)}>
          {showBreakdown ? 'Hide breakdown' : 'Show breakdown'}
          <i className={`fas ${showBreakdown ? 'fa-chevron-up' : 'fa-chevron-down'}`} />
        </span>
      </div>

      {showBreakdown && (
      <div className="estimated-summary-container">
        <div className="line">
          <p>
            {totalCapacity}ATs x {totalDuration}hrs x {displayRate()}
          </p>
          <span>${setPrecision(totalRate)}</span>
        </div>
        <div className="line">
          <p>Go4 service fee ({fee}%)</p>
          <span>${setPrecision(locationServiceFee)}</span>
        </div>

        <div className="horizontal-line" />

        <div className="line bold">
          <p>Estimated total</p>
          <span>${setPrecision(estimatedTotal)}</span>
        </div>

        <p className="estimated-notice">
          Estimate uses the {totalCapacity} ATs, {shifts.length} {shifts.length === 1 ? 'shift' : 'shifts'}{' '}
          and {totalCapacity} hours in your schedule. You are billed for hours actually worked.
        </p>
      </div>
      )}
    </div>
  );
};
